import React from 'react';
import { DQBElement } from '../../types/DQB';
import DQBItem from './DQBItem';

interface DQBChapterListProps {
    dqbItems: DQBElement[];
    bookId: any
}

const DQBList: React.FC<DQBChapterListProps> = ({ dqbItems, bookId }) => {
    return (
        <div className="mt-4">
            {dqbItems.map(
                (dqbItem, index) =>
                    dqbItem.title && (
                        <div key={index}>
                            <DQBItem dqbItem={dqbItem} bookId={bookId} />
                            {index !== dqbItems.length - 1 && (
                                <hr className="border-gray-400  border-1 opacity-50 border-dashed" />
                            )}
                        </div>
                    )
            )}
        </div>
    );
};

export default DQBList;
